import {Component, OnDestroy, OnInit} from '@angular/core';
import {LayoutEditDetailsService} from "../services/layout-edit-details.service";
import { Layout } from '@docma-mm-core/layout/layout';
import {LayoutFieldExt} from "@docma-mm-core/layout/layout-field";
import {UntilDestroy} from "@ngneat/until-destroy";
import {LayoutFilter} from "@docma-mm-core/layout/layout-filter";
import {User} from "@docma-mm-core/user/user";
import {Project} from "@docma-mm-core/project/project";

@UntilDestroy()
@Component({
  selector: 'mydocma-mm-layout-edit-details',
  templateUrl: './layout-edit-details.component.html',
  styleUrls: ['./layout-edit-details.component.scss'],
  providers: [ LayoutEditDetailsService ]
})
export class LayoutEditDetailsComponent implements OnInit, OnDestroy {

  private editArgs: {Layout: Layout, Fields: LayoutFieldExt[], Filters: LayoutFilter[], IsNew: boolean, project: Project, user: User, hasReferences: boolean};

  constructor(public readonly detailsService: LayoutEditDetailsService) {
  }

  ngOnInit(): void {

  }

  ngOnDestroy() {

  }

  initialize(editArgs: {Layout: Layout, Fields: LayoutFieldExt[], Filters: LayoutFilter[], IsNew: boolean, project: Project, user: User, hasReferences: boolean}) {
    this.editArgs = editArgs;
    this.detailsService.loadForm(this.editArgs);
  }

  validate() {
    return this.detailsService.validate();
  }
}
